import React, { useEffect } from 'react';
import { formatDate } from '../../../../utils/helper';
import './ReturnExchangeSuccessCard.scss';

function ReturnExchangeSuccessCard(props) {
  const {
    status,
    txnObj,
    msg,
    loading,
    desc,
    estimatedDate,
    getOrder,
    orderDetails,
    buttonText,
    buttonClickHandler,
    topazButtonText,
    topazButtonClickHandler,
    info,
    intiateRefund,
    intiateExchange,
    returnDetails,
    viewPolicyHandler,
    returnMethod,
    returnProductsFromStorage,
    initiateExchangeOrRefund,
    onNeedHelpClickHandler,
    pickupInformation,
    dataLocale,
  } = props;
  const {
    CHOOSE_EXCHANGE_OR_REFUND,
    VIEW_POLICY,
    PROCEED_FOR_REFUND,
    EXCHANGE_PRODUCT_NOW,
    NEED_REFUND_INSTEAD,
    NEED_HELP,
    QUESTION_MARK,
    CHAT_WITH_US,
  } = dataLocale;
  let icon;
  let ctaButtons;
  let policyText;
  let showChatWithUs = true;
  if (status === 'failure') {
    icon = 'CrossOrange.svg';
  } else if (status === 'pending') {
    icon = 'Pending.svg';
  } else if (status === 'newRefund') {
    icon = 'TickGreen.svg';
  } else if (status === 'inExchange') {
    icon = 'TickGreen.svg';
  } else {
    icon = 'TickGreen.svg';
    showChatWithUs = false;
  }
  useEffect(() => {
    if (
      txnObj &&
      txnObj.txnId &&
      txnObj.txnId !== orderDetails?.result?.orders?.[0]?.id &&
      !loading
    ) {
      getOrder({ orderId: txnObj.txnId, dontInitSession: true, isMyAcct: true });
    }
  }, [txnObj]);
  if (
    returnMethod !== 'store_return' &&
    returnDetails &&
    returnProductsFromStorage &&
    returnProductsFromStorage.length === 1
  ) {
    const { isRefundable, isExchangeable } = returnDetails;
    if (isRefundable && isExchangeable) {
      ctaButtons = (
        <div className="cta-buttons display-flex mr-t10" style={{ flexDirection: 'column' }}>
          <button
            className="new-btn cursor-pointer fsp16 fw500 exchange-btn item-returned order-1 mr-t20"
            onClick={initiateExchangeOrRefund}
          >
            <span className="fsp14 lh-16 fw500 text-uppercase">{CHOOSE_EXCHANGE_OR_REFUND}</span>
          </button>
        </div>
      );
    } else if (isRefundable || isExchangeable) {
      ctaButtons = (
        <div className="cta-buttons display-flex mr-t10" style={{ flexDirection: 'column' }}>
          {isRefundable ? (
            <button
              className="new-btn cursor-pointer fsp16 fw500 exchange-btn item-returned order-1 mr-t20"
              onClick={intiateRefund}
            >
              <span className="fsp14 lh-16 fw500 text-uppercase">{PROCEED_FOR_REFUND}</span>
            </button>
          ) : (
            <React.Fragment>
              <button
                className="new-btn cursor-pointer fsp16 fw500 exchange-btn item-returned order-1 mr-t20"
                onClick={intiateExchange}
              >
                <span className="fsp14 lh-16 fw500 text-uppercase">{EXCHANGE_PRODUCT_NOW}</span>
              </button>
              <span className="order-1 mr-t15 text-color_grey_black fw700 text-left">
                {NEED_REFUND_INSTEAD}
              </span>
            </React.Fragment>
          )}
        </div>
      );
      //     <button className={`new-btn fsp16 fw500 exchange-btn ${isRefundable ? ' item-returned order-1 mr-t20' : ' order-2 mr-t12 exchange-btn-disabled'}`} disabled={!isRefundable} onClick={intiateRefund}>
      //     <span className="fsp14 lh-16 fw500">GET A REFUND
      //     </span>
      // </button>
      //     <button className={`new-btn fsp16 fw500 exchange-btn ${isExchangeable ? ' item-returned order-1 mr-t20' : ' order-2 mr-t12 exchange-btn-disabled'}`} disabled={!isExchangeable} onClick={intiateExchange}>
      //     <span className="fsp14 lh-16 fw500">EXCHANGE PRODUCT NOW
      //     </span>
      // </button>;
      // policyText = isRefundable ? 'Exchange is not allowed on this product as per policy.' : 'Refund Option may be available as per policy after Lenskart receives and inspects the product';
      policyText = isExchangeable
        ? 'When the product is received by Lenskart, you will receive communication from us to choose Exchange or Refund'
        : '';
    } else {
      // ctaButtons = (<div className="cta-buttons border-top mr-t10"><button className="new-btn fsp16 fw500 exchange-btn mr-t20 exchange-btn-disabled">
      //     <span className="fsp14 lh-16 fw500">EXCHANGE PRODUCT / GET REFUND</span>
      // </button>
      // </div>);
      // policyText = 'Exchange & Refund is not allowed on this product right now as per policy. These options may be available after Lenskart receives and inspects your product.';
    }
  }
  return (
    <div className="pd-20 bg-color_white mr-b10 text-center display-flex align-items-center flex-column justify-content-center roboto">
      <div className="mr-b8">
        <img
          alt="icon"
          aria-label="Status Icon"
          src={`https://static.lenskart.com/media/mobile/universal/images/returnExchange/${icon}`}
          style={{ width: '40px' }}
        />
      </div>
      {Boolean(pickupInformation || msg) && (
        <div className="fw500  mr-b8 margin-t12 margin-b6 fs20 lh-20 text-color_black">
          {pickupInformation}
          {pickupInformation && msg ? ' & ' : ''}
          {msg}
        </div>
      )}
      {Boolean(txnObj && txnObj.txnId) && (
        <div className="fsp16 lh-20 mr-b8 text-color-primary fw700">
          {txnObj.txnText} - {txnObj.txnId}
        </div>
      )}
      {desc &&
        desc.map((descItem, index) => {
          let displayDescItem = typeof descItem === 'string' ? descItem + '' : descItem;
          if (typeof descItem === 'string' && descItem?.indexOf('{') > -1) {
            displayDescItem = displayDescItem.replace(
              /\{.*?[^\}]\}/g,
              formatDate(estimatedDate, 'D MMM', 'year')
            );
          }
          return (
            <div
              key={`desc-${index}`}
              className="lh-15 fs13 margin-b6 text-color-grey mr-b4 margin-l12 margin-r12 "
              data-testid="descText"
            >
              <span dangerouslySetInnerHTML={{ __html: displayDescItem }} />
              {/* {estimatedDate && index === 0 && <span className="date"> {formatDate(estimatedDate, 'MMM D,', 'year')}</span>} */}
            </div>
          );
        })}
      <div className="display-flex align-items-center justify-content-center">
        {buttonText && (
          <React.Fragment>
            <div
              className="margin-t2 view-label text-color-primary cursor-pointer roboto text-uppercase"
              style={{ width: '400px' }}
              onClick={buttonClickHandler}
            >
              {buttonText}
            </div>
          </React.Fragment>
        )}
        {topazButtonText && (
          <React.Fragment>
            <div
              className="topaz view-label text-color-white cursor-pointer mr-t10 margin-b10 fw700 fsp12 margin-l13 margin-t12 text-center align-items-center width65 lh-14 roboto"
              onClick={topazButtonClickHandler}
            >
              {topazButtonText}
            </div>
          </React.Fragment>
        )}
      </div>
      {
        info ? (
          <div
            className="fsp12 lh-15 text-color_dull_black mr-t10"
            dangerouslySetInnerHTML={{ __html: info }}
          />
        ) : null
        // <React.Fragment> // UAT Feedback https://docs.google.com/document/d/1w5YVn9303gphsMMx4uE1PQMmFktdNPeac34YQpl9xkE/edit?ts=606d421e
        //     {!returnId && !refundId && orderId && // returnId || refundId ||
        //         <div className="fsp14 lh-16 mr-t16">
        //             <span className="text-color_pale_black">New Order ID: </span> {/* {returnId || refundId ? 'Request ID' : 'New Order ID'} */}
        //             <span className="text-color_grey_black fw700">{orderId}</span> {/* {returnId || refundId || orderId} */}
        //         </div>
        //     }
        // </React.Fragment>
      }
      {showChatWithUs && (
        <React.Fragment>
          <div className="display-flex justify-content-around">
            <div className="text-color_pale_black fs14 text-color-grey mr-t10 margin-t12 margin-b2">
              {NEED_HELP}
              {QUESTION_MARK}
            </div>
            <div
              className="mr-t8 text-color-primary margin-l13 margin-t8 bg-white cursor-pointer inline-block padding-t5 padding-b5 pd-b8 pd-l10 bora-4 fw700 fsp12 lh-14 roboto text-uppercase"
              onClick={onNeedHelpClickHandler}
            >
              {CHAT_WITH_US}
            </div>
          </div>
        </React.Fragment>
      )}
      {Boolean(ctaButtons) && (
        <React.Fragment>
          {ctaButtons}
          {policyText && (
            <div className="display-flex align-items-center" data-testid="policyText">
              <div className="roboto text-center mr-t10 text-color_grey_black fsp12 text-left flex-1">
                {policyText}
              </div>
              <div
                className="roboto text-center cursor-pointer mr-t10 text-color-primary fsp12 mr-l10 fw700"
                onClick={viewPolicyHandler}
              >
                {VIEW_POLICY}
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

export default ReturnExchangeSuccessCard;
